import Swal from "sweetalert2";

import api from "./api";
import { GetLogRetornoDto, GetLogRetornosGroupTypeDto } from "../shared/dtos/LogRetornos";

class LogRetornosService {
    async getAllLogRetornos(): Promise<GetLogRetornoDto[]> {
        return api
            .get("/log-retornos/getAll")
            .then((response) => {
                return Promise.resolve(response.data as GetLogRetornoDto[]);
            })
            .catch((error) => {
                this.handleError(error, `Erro ao buscar log de retornos`);
                return Promise.reject(error);
            });
    }

    async getLogRetornosById(id: number): Promise<GetLogRetornoDto> {
        return api
            .get(`/log-retornos/findOne/${id}`)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                this.handleError(error, `Erro ao buscar log de retornos com ID ${id}`);
                return Promise.reject(error);
            });
    }

    async getAllLogRetornosByIdReturn(id: number): Promise<GetLogRetornosGroupTypeDto[]> {
        return api
            .get(`/log-retornos/get-all-by-return/${id}`)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                this.handleError(error, `Erro ao buscar log de retornos com ID ${id}`);
                return Promise.reject(error);
            });
    }


    private handleError(error: any, message: string): void {
        if (error.response) {
            Swal.fire({
                title: "Erro",
                text: `${message}: ${error.response.data}`,
                icon: "error",
                confirmButtonText: "Fechar",
                allowOutsideClick: false,
            });
        } else {
            Swal.fire({
                title: "Erro",
                text: `${message}: ${error.message || "Erro desconhecido"}`,
                icon: "error",
                confirmButtonText: "Fechar",
                allowOutsideClick: false,
            });
        }
    }
}

const logRetornosService = new LogRetornosService();
export default logRetornosService;
